import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import axios from 'axios'
// nodejs library that concatenates classes
import classnames from 'classnames'
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from 'reactstrap'
// core components
import AuthHeader from 'components/Headers/AuthHeader.js'

import AxiosInstance from 'utils/AxiosInstance'

const ForgotPassword = () => {
  //dev.admin@startkiwi.com
  const [email, setEmail] = useState('')
  const [emailSent, setEmailSent] = useState(false)

  const data = { email }
  const sendEmail = (e) => {
    e.preventDefault()

    AxiosInstance.post('/users/forgot-password', data).then((response) => {
      if (!response) {
        alert('Something went wrong!')
        return
      }

      if (response.success) {
        setEmailSent(true)
      } else {
        alert(response.message)
      }
    })
  }

  return (
    <>
      <AuthHeader title='' lead='' className='pt-0' />
      <Container className='mt--9 pb-5'>
        {emailSent ? (
          <Row className='justify-content-center'>
            <Col lg='5' md='7'>
              <Card className='bg-secondary border-0 mb-0'>
                <CardBody className='px-lg-5 py-lg-5'>
                  <div className='text-center text-muted  pt-3'>
                    <h3>Email sent successfully.</h3>
                    <h3>Please check your email.</h3>
                  </div>
                  <div className='text-center text-muted  pt-3'>
                    <Link to='/login'>Login</Link>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        ) : (
          <Row className='justify-content-center'>
            <Col lg='5' md='7'>
              <Card className='bg-secondary border-0 mb-0'>
                <CardBody className='px-lg-5 py-lg-5'>
                  <div className='text-center text-muted mb-4 pt-3'>
                    <h2>Forgot Your Password ?</h2>
                    <small>
                      Please Enter Your Email to Change your Password
                    </small>
                  </div>
                  <Form role='form' data-cy='login-form'>
                    <FormGroup
                      className={classnames('mb-3', {
                        // focused: focusedEmail,
                      })}
                    >
                      <InputGroup className='input-group-merge input-group-alternative'>
                        <InputGroupAddon addonType='prepend'>
                          <InputGroupText>
                            <i className='ni ni-email-83' />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          data-cy='email'
                          placeholder='Email'
                          type='email'
                          defaultValue={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </InputGroup>
                    </FormGroup>

                    <div className='text-center'>
                      <Button
                        className='my-3 px-4'
                        color='info'
                        type='submit'
                        data-cy='submit'
                        onClick={sendEmail}
                      >
                        Continue
                      </Button>
                    </div>
                  </Form>
                  <div className='text-center text-primary'>
                    <Link className='text-primary' to='/login'>
                      Login
                    </Link>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </Container>
    </>
  )
}

export default ForgotPassword
